import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
export const ExperienceSection = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const techStacks = [
    {
      name: "React",
      logo: "https://raw.githubusercontent.com/devicons/devicon/master/icons/react/react-original.svg",
      experience: "4+ years",
      projects: ["E-commerce Platform", "Admin Dashboard", "Social Media App"],
      color: "from-cyan-500 to-blue-500",
    },
    {
      name: "Angular",
      logo: "https://raw.githubusercontent.com/devicons/devicon/master/icons/angularjs/angularjs-original.svg",
      experience: "3+ years",
      projects: ["Enterprise CRM", "Analytics Dashboard", "Booking System"],
      color: "from-red-500 to-pink-500",
    },
    {
      name: ".NET",
      logo: "https://raw.githubusercontent.com/devicons/devicon/master/icons/dot-net/dot-net-original.svg",
      experience: "2+ years",
      projects: [
        "Microservices Architecture",
        "REST APIs",
        "Authentication System",
      ],
      color: "from-purple-500 to-indigo-500",
    },
    {
      name: "Webflow",
      logo: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/webflow/webflow-original.svg",
      experience: "2+ years",
      projects: [
        "Web Design and Development",
        "Landing Page Design",
        "Responsive Web Design"
      ],
      color: "from-blue-500 to-purple-500",
    },
    {
      name: "NestJS",
      logo: "https://nestjs.com/img/logo-small.svg"
,
      experience: "2+ years",
      projects: ["RESTful APIs", "Microservices", "GraphQL API Development"],
      color: "from-yellow-500 to-orange-500",
    },
    {
      name: "HTML5",
      logo: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
      experience: "5+ years",
      projects: ["Landing Pages", "Web Applications", "SEO Optimization"],
      color: "from-red-500 to-orange-500",
    },
    {
      name: "CSS3",
      logo: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
      experience: "5+ years",
      projects: ["Web Design", "Responsive Layouts", "Animations & Transitions"],
      color: "from-blue-500 to-indigo-500",
    },
    {
      name: "JavaScript",
      logo: "https://raw.githubusercontent.com/devicons/devicon/master/icons/javascript/javascript-original.svg",
      experience: "4+ years",
      projects: ["E-commerce Platform", "Admin Dashboard", "Social Media App"],
      color: "from-yellow-400 to-yellow-500",
    },
    {
      name: "TypeScript",
      logo: "https://raw.githubusercontent.com/devicons/devicon/master/icons/typescript/typescript-original.svg",
      experience: "4+ years",
      projects: ["React Applications", "API Services", "Angular Projects"],
      color: "from-blue-400 to-blue-600",
    },
  ];

  return (
    <section className="relative py-20 px-4 overflow-hidden" id="skills">
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900/50 via-blue-900/10 to-purple-900/30 backdrop-blur-3xl" />
      <motion.div
        ref={ref}
        initial={{ opacity: 0 }}
        animate={inView ? { opacity: 1 } : { opacity: 0 }}
        transition={{ duration: 0.8 }}
        className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10"
      >
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.8 }}
          className="text-4xl sm:text-5xl font-bold mb-16 text-center"
        >
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400 relative">
            Experience & Skills
            <div className="absolute -bottom-4 left-1/2 transform -translate-x-1/2 w-24 h-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full blur-sm" />
          </span>
        </motion.h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {techStacks.map((tech, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }}
              transition={{ duration: 0.8, delay: index * 0.2 }}
              className="relative group"
            >
              <div className={`absolute inset-0 bg-gradient-to-r ${tech.color} opacity-0 group-hover:opacity-100 blur-xl transition-opacity duration-500`} />
              <div className="relative bg-black/50 backdrop-blur-xl rounded-xl p-8 border border-white/10 hover:border-white/20 transition-colors duration-500 group-hover:transform group-hover:scale-[1.02] group-hover:-translate-y-1 transition-all">
                <div className="flex items-center space-x-6">
                  <div className="relative">
                    <div className={`absolute inset-0 bg-gradient-to-r ${tech.color} blur-md opacity-50 rounded-full`} />
                    <img src={tech.logo} alt={tech.name} className="w-16 h-16 relative z-10" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-semibold mb-2 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">
                      {tech.name}
                    </h3>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};
